import React from 'react';
import { FadeUp, countries, EYEBROW, GRAD_TEXT } from './shared';

const Countries = ({ onStart }) => (
  <section style={{ padding: '0 1.5rem 7rem', maxWidth: '1024px', margin: '0 auto' }}>
    <FadeUp>
      <div style={{ marginBottom: '3rem' }}>
        <span style={EYEBROW}>Destinations</span>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', fontWeight: 800, color: '#302B2C', letterSpacing: '-0.03em', lineHeight: 1.05, marginTop: '0.75rem' }}>
          Assess eligibility across <span style={GRAD_TEXT}>20+ countries</span>
        </h2>
      </div>
    </FadeUp>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '16px' }}>
      {countries.map((c, i) => (
        <FadeUp key={c.name} delay={i * 0.06}>
          <div data-testid={`country-card-${i}`} className="img-card" style={{
            position: 'relative', borderRadius: '2px', overflow: 'hidden',
            border: '1px solid rgba(48,43,44,0.1)', cursor: 'pointer', height: '160px',
          }}
            onClick={onStart}
          >
            <div className="img-card-bg" style={{ position: 'absolute', inset: 0, backgroundImage: `url(${c.img})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(48,43,44,0.85) 0%, rgba(48,43,44,0.25) 55%, transparent 100%)' }} />
            <div style={{ position: 'relative', zIndex: 1, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '1rem 1.25rem' }}>
              <span style={{ fontSize: '1.75rem', marginBottom: '4px' }}>{c.flag}</span>
              <h4 style={{ fontFamily: 'var(--font-heading)', fontSize: '1rem', fontWeight: 800, color: '#fff', margin: 0 }}>{c.name}</h4>
              <span style={{ fontFamily: 'var(--font-body)', fontSize: '0.65rem', fontWeight: 700, color: '#FCA96E', letterSpacing: '0.06em', textTransform: 'uppercase' }}>{c.program}</span>
            </div>
          </div>
        </FadeUp>
      ))}
    </div>
    <FadeUp delay={0.3}>
      <p style={{ textAlign: 'center', marginTop: '2rem', fontFamily: 'var(--font-body)', fontSize: '0.875rem', color: 'rgba(48,43,44,0.5)' }}>
        + Spain, France, Netherlands, Greece, Croatia, UAE, Mexico, Malta, Cyprus, Costa Rica and more
      </p>
    </FadeUp>
  </section>
);

export default Countries;
